import {FC} from 'react'

type Props = {
  domain?: string
  showCredentialsHint?: boolean
}

const Bitrix24LocalAppInstruction: FC<Props> = ({domain, showCredentialsHint = true}) => (
  <div className='alert alert-primary d-flex align-items-center mt-3 mb-3'>
    <div className='d-flex flex-column'>
      <h5 className='mb-1'>Установите локальное приложение на своем Bitrix24</h5>
      {domain && (
        <a href={`https://${domain}/devops/section/standard/`} target='_blank' rel='noreferrer'>
          Установка локального приложения
        </a>
      )}

      <span className='text-muted'>
        Заполните поля: <br />- Локальное приложение: <code className='fs-9'>Серверное</code> <br />- Путь вашего
        обработчика: <code className='fs-9'>https://api.callbee.io/crm/bitrix24</code> <br />- Путь для
        первоначальной установки: <code className='fs-9'>https://api.callbee.io/crm/bitrix24</code> <br />-
        Выберете: <code className='fs-9'>Использует только API</code> <br />- Настройка прав:
        <br /> <code className='fs-9'>CRM (crm)</code>
        <br /> <code className='fs-9'>Телефония (telephony)</code>
        <br /> <code className='fs-9'>Пользователи (user)</code>
        <br /> <code className='fs-9'>Телефония (совершение звонков) (call)</code>
        {showCredentialsHint && (
          <>
            <br />
            Заполните поля ниже <br />
            <code className='fs-9'>Код приложения (client_id)</code>
            <br />
            <code className='fs-9'>Ключ приложения (client_secret)</code>
          </>
        )}
      </span>
    </div>
  </div>
)

export {Bitrix24LocalAppInstruction}
